/**
 * Enable Insider new Terms and Conditions - Phase 1B - includes benefits modal, checkout and account settings.
 */
export const INSIDER_TERMS_AND_CONDITIONS_PHASE_1B_ENABLED_231130 = 'INSIDER_TERMS_AND_CONDITIONS_PHASE_1B_ENABLED_231130';
